import {Component, HostListener, Input, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {AppService} from '../../services/app.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  // for categories
  categoriesReceived = false;
  categories: any = [];
  currentCategoryID = '';
  currentCategorySlug = '';
  public _extraClass = '';
  footerSelectedCity = '';

  @Input()
  get extraClass(): string {
    return this._extraClass;
  }

  set extraClass(flag: string) {
    this._extraClass = flag;
  }

  constructor(
    private http: HttpClient,
    private router: Router,
    private activedRoute: ActivatedRoute,
    public appService: AppService
  ) {
    this.footerSelectedCity = localStorage.getItem('city');
  }

  ngOnInit(): void {
    // get selected city
    this.footerSelectedCity = localStorage.getItem('city');
    this.getCategories();
    // this.checkSession();
  }


  checkSession(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: localStorage.getItem('accessToken')})
    };

    this.http.get <any>(environment.domain + '/api/verify-token', httpOptions).subscribe(
      data => {
        console.log('session data', data);
      },
      error => {
        console.error('There was an error!', error);
      });
  }

  getCategories(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    this.http.post <any>(environment.domain + '/api/categories', {}, httpOptions).subscribe(
      data => {
        this.categoriesReceived = true;
        this.categories = data.categories;

        this.categories.EXPERIENCE.forEach((category, index) => {
          if (category.category_name.toLowerCase() === this.currentCategorySlug) {
            this.currentCategoryID = category.id;
          }
        });

        this.categories.STANDARD.forEach((category, index) => {
          if (category.category_name.toLowerCase() === this.currentCategorySlug) {
            this.currentCategoryID = category.id;
          }
        });

      },
      error => {
        console.error('There was an error!', error);
      });
  }

}
